export const SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER";
export const CLEAR_LOGGED_IN_USER = "CLEAR_LOGGED_IN_USER";
export const SET_DETAILS_SCREEN_IDS = "SET_DETAILS_SCREEN_IDS";
export const CLEAR_DETAILS_SCREEN_IDS = "CLEAR_DETAILS_SCREEN_IDS";
